import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, defineMessages } from 'react-intl';
import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';
import { DEFAULT_ORDERS_PAGE_URL } from '../../../../../services/user-permission-service';

const messages = defineMessages({
  title: {
    description: 'customersPlaceholder.title',
    defaultMessage: 'You have no {statusView} to view',
    id: 'DfS7z6',
  },
  description: {
    description: 'customersPlaceholder.description',
    defaultMessage: 'No customers data to view at the moment',
    id: 'JAdBDf',
  },
  boldStatusView: {
    description: 'customersPlaceholder.boldStatusView',
    defaultMessage: 'Customers',
    id: 'GvqrAs',
  },
});

const CustomersGridPlaceholder = () => {
  const history = useHistory();

  const action = useCallback(() => {
    history.push(DEFAULT_ORDERS_PAGE_URL);
  }, [history]);

  return (
    <ActionablePlaceholder
      action={action}
      description={<FormattedMessage {...messages.description} />}
      title={
        <FormattedMessage
          {...messages.title}
          values={{
            statusView: (
              <b>
                <FormattedMessage {...messages.boldStatusView} />
              </b>
            ),
          }}
        />
      }
    />
  );
};

export default CustomersGridPlaceholder;
